import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ThemeCustomizerService } from './../common/theme-customizer/theme-customizer.service';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, RouterLink } from '@angular/router';
import { PublicServiceService } from 'src/app/public-service.service';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/admin/auth.service';
import { catchError, of } from 'rxjs';

@Component({
    selector: 'app-login-page',
    standalone: true,
    imports: [RouterLink, ReactiveFormsModule, CommonModule],
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {

    isToggled = false;
    title = "Ale-Shansab|Login";
    loginForm: FormGroup;
    invalidLogin = ''
    constructor(
        public themeService: ThemeCustomizerService, 
        private titleService: Title, 
        private authService: AuthService,
        private formBuilder: FormBuilder, 
        private router: Router
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.titleService.setTitle($localize `${this.title}`)
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void {
        this.createLoginForm()

    }

    createLoginForm() {
        this.loginForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.maxLength(30)]]
        })
    }

    get loginFrm() {
        return this.loginForm.controls
    }

    login() {
        if (!this.loginForm.invalid) {
            let loginData = new FormData()
            loginData.append("username", this.loginForm.get("username").value)
            loginData.append("password", this.loginForm.get("password").value)
   
            this.authService.login(loginData).subscribe({
                next: (res) => {
                    this.invalidLogin = ''
                    this.authService.saveToken(res['access_token'], res["expire_at"])
                    this.router.navigateByUrl("admin/dashboard")
                    
                },
            error: (error)=> {
                // This error branch won't be called due to catchError
                this.invalidLogin = error
                console.error("here goes the Unexpected error:", error);
            }})
        } else {
            console.error("Invalid Input credintials")
        }
    }



}